import React, { useCallback } from "react";
import PropTypes from "prop-types";
import { Grid } from "@material-ui/core";
import { CustomTextField } from "@totalsoft/rocket-webapp-components-deprecated";
import { emptyString } from "constants/defaultValues";
import { useTranslation } from "react-i18next";

function AssetDescriptionContent({ dialogState, setDialogState }) {
  const { t } = useTranslation();

  const handleChange = useCallback(
    (event) => {
      setDialogState({ assetDescription: event.target.value });
    },
    [setDialogState]
  );

  return (
    <Grid container>
      <Grid item xs={12}>
        <CustomTextField
          fullWidth
          label={t("Asset.Description")}
          value={dialogState.assetDescription || emptyString}
          onChange={handleChange}
        />
      </Grid>
    </Grid>
  );
}

AssetDescriptionContent.propTypes = {
  dialogState: PropTypes.object.isRequired,
  setDialogState: PropTypes.func.isRequired,
};

export default AssetDescriptionContent;
